import React from 'react'

interface SkeletonProps {
    className?: string
    style?: React.CSSProperties
    height?: string
    width?: string
    loading: boolean
    children?: any
}

export const Skeleton: React.FC<SkeletonProps> = ({
    className = '',
    loading,
    style,
    height,
    width,
    children,
}) => {
    if (!loading) {
        return <>{children}</>
    }
    return (
        <div
            className={`skeleton ${className}`} // Passing className correctly
            style={{ height, width, ...style }} // Dynamically applying inline styles
        ></div>
    )
}
